import React, { useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Layout from '../../../Components/Layout/Layout';
import CalendarFilters from '../../../Components/CalendarFilters/Index';
import CalenderModals from '../../../Components/Modals/Index';

const localizer = momentLocalizer(moment);

const CustomToolbar = ({ label, onNavigate }) => {
  return (
    <div className="rbc-toolbar">
      <span className="rbc-btn-group-dash">
        <button type="button" onClick={() => onNavigate('PREV')}>
          &lt;&lt;
        </button>
        <span className="rbc-toolbar-label">{label}</span>
        <button type="button" onClick={() => onNavigate('NEXT')}>
          &gt;&gt;
        </button>
      </span>
    </div>
  );
};

const MonthlyView = () => {
  const [events, setEvents] = useState([
    {
      title: 'Team Meeting',
      start: new Date(2024, 10, 5, 10, 0),
      end: new Date(2024, 10, 5, 12, 0),
      desc: 'Monthly strategy meeting for the team',
      backgroundColor: '#a3d9f5',
      textColor: '#07477d',
    },
    {
      title: 'Project Deadline',
      start: new Date(2024, 10, 15, 8, 0),
      end: new Date(2024, 10, 15, 17, 0),
      desc: 'Final submission of the quarterly project',
      backgroundColor: '#f3abab',
      textColor: '#7d1c1c',
    },
  ]);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedEvent(null);
  };

  const eventPropGetter = (event) => ({
    style: {
      backgroundColor: event.backgroundColor,
      color: event.textColor,
      padding: '5px 5px',
      border: 'none',
    },
  });

  return (
    <Layout>
      <CalendarFilters />
      <div style={{ height: '80vh', margin: '20px' }}>
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{ height: '100%' }}
          eventPropGetter={eventPropGetter}
          view="month" // Always show monthly view
          onView={() => {}} // Disable view change
          components={{
            toolbar: CustomToolbar,
            event: ({ event }) => (
              <div
                className="custom-event"
                onClick={() => handleEventClick(event)}
              >
                <strong
                  style={{
                    backgroundColor: event.textColor,
                    color: event.backgroundColor,
                  }}
                >
                  {event.title}
                </strong>
                <span>{event.desc}</span>
              </div>
            ),
          }}
        />
      </div>
      <CalenderModals
          open={modalOpen}
          onClose={handleModalClose}
          event={selectedEvent}
        />
    </Layout>
  );
};

export default MonthlyView;
